// categoryOrder — Sichtlisten-Hilfsfunktionen für die Kategorie-Reihenfolge-Aktionen
// (⋮-Menü „Nach oben"/„Nach unten" in MobileCategorySection). `categories` (aus
// useDeckViewState) enthält die Commander-Kategorie ungefiltert — der Commander-Ausschluss
// passiert erst bei der Gruppen-Bildung (useDeckViewState.js). Naive Index-Arithmetik auf
// dem vollen Array würde bei einem dazwischenliegenden Commander-Eintrag mit ihm tauschen;
// beide Funktionen hier rechnen deshalb ausschließlich auf der gefilterten Sichtliste.

/** Kategorien ohne die Commander-Kategorie, in Server-Reihenfolge. */
export function visibleCategoryOrder(categories) {
  return (categories || []).filter((c) => !c.isCommander);
}

/**
 * Nachbar von `name` in der Sichtliste für „Nach oben" (`direction: 'up'`) bzw.
 * „Nach unten" (`direction: 'down'`). `null`, wenn `name` an einem Ende der Sichtliste
 * steht (Menüpunkt ist dort disabled) oder gar nicht in ihr vorkommt.
 */
export function findCategoryNeighbor(categories, name, direction) {
  const visible = visibleCategoryOrder(categories);
  const idx = visible.findIndex((c) => c.name === name);
  if (idx === -1) return null;
  const neighborIndex = direction === 'up' ? idx - 1 : idx + 1;
  return visible[neighborIndex] || null;
}
